import {Component, OnInit} from '@angular/core';
import {of, Subject} from 'rxjs';
import {debounceTime, distinctUntilChanged, takeUntil, mergeMap} from 'rxjs/operators';
import {CaseClient, CaseSearchResult} from '../../../shared/apis/api.client';
import {Router} from '@angular/router';
import {Disposable} from '../../../shared/extensions/disposable';
import {ProgressService} from '../../services/progress.service';

@Component({
    selector: 'app-search',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss']
})
export class SearchComponent extends Disposable implements OnInit {
    get searchText(): string {
        return this._searchText;
    }

    set searchText(searchText: string) {
        this._searchText = searchText && typeof searchText === 'string' ? searchText.trim() : '';
    }

    private _searchText = '';
    searchTextSubject = new Subject<string>();
    searchLimit = 5;
    cases: CaseSearchResult[];
    searching = false;

    constructor(private caseClient: CaseClient, private router: Router, private progress: ProgressService) {
        super();
    }

    ngOnInit(): void {
        this.searchTextSubject
            .pipe(debounceTime(1000), takeUntil(this.$destroyed), mergeMap((_) => {
                return this.searchText ? this.caseClient.quickSearch(this.searchText, this.searchLimit) : of({cases: []});
            })).subscribe({
            next: (next) => {
                this.cases = next.cases;
                this.searching = false;
            }
        });
    }

    onSearchTextInput(): void {
        if (!this.searchText) {
            return;
        }
        this.searching = true;
        this.searchTextSubject.next(this.searchText);
    }

    onResultClick(caseResult: CaseSearchResult): void {
        if (!caseResult) {
            return;
        }
        this.progress.setLoadingState(true);
        this.searchText = '';
        const path = caseResult.isDraft ? 'cases/edit-partial' : 'cases/view';
        this.router.navigate([path, caseResult.caseNumber]).then(() => {
            this.progress.setLoadingState(false);
        });
    }

    isDraft(caseResult: CaseSearchResult): boolean {
        return caseResult.isDraft;
    }
}
